import { styled } from '@abyss/web/tools/styled';

export const getCardStyles = (phoneScreen) => ({
  height: phoneScreen ? '213px' : '246px',
  justifyContent: 'space-between',
  opacity: 1,
  width: phoneScreen ? '384px' : '404px',
  borderRadius: '8px',
  borderWidth: '1px',
  border: '1px solid #E5E5E6',
  display: 'flex',
  flexDirection: 'column',
  padding: phoneScreen ? '0px' : '6px',
  '&.abyss-card-root': {
    marginTop: '0px !important',
    maxWidth: phoneScreen ? '318px' : '408px',
  },
  '&:active, &:focus, &:hover': {
    border: '2px solid $interactive2',
  },
  '.abyss-card-section:first-child': {
    flexGrow: 1,
  },
});
export const getImageStyles = (phoneScreen) => ({
  height: 50,
  marginBottom: 0,
  maxWidth: phoneScreen ? '100px' : '143px',
  objectFit: 'contain' as const,
  margin: '0px',
  size: 'contain' as const,
});
export const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: '125px 1fr',
    gridTemplateRows: 'auto',
    width: '100%',
    margin: '0px',
  },
  imageContainer: {
    display: 'flex',
    margin: '0px',
  },
  image: {
    height: 50,
    marginBottom: 0,
    maxWidth: '143px',
    objectFit: 'contain' as const,
    margin: '0px',
    size: 'contain' as const,
  },
};

export const getBadgeStyles = (phoneScreen) => ({
  '&.abyss-badge-root': {
    height: '38px',
    maxWidth: phoneScreen ? '130px' : '143px',
    borderRadius: '4px',
    padding: phoneScreen ? '0px' : '16px',
    margin: '4px',
    textWrap: 'wrap',
    fontSize: phoneScreen ? '11px' : '11.25px',
    fontWeight: 'normal !important',
    whiteSpace: 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  '&.abyss-badge-content': {
    fontWeight: 'normal !important',
  },
  '& *': {
    fontWeight: 'normal !important',
  },
});
export const NetworkWrapper = styled('div', {
  lineHeight: '18px',
  marginTop: '27px',
  color: '#323333',
  fontSize: '14px',
  marginLeft: '0px',
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  paddingLeft: '0px',
  alignItems: 'center',
});
export const VirtualVisitLabel = styled('div', {
  lineHeight: '18px',
  marginTop: '5px',
  color: '#323333',
  marginLeft: '0px',
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  paddingLeft: '0px',
  alignItems: 'center',
});
